<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="form-group">
          <h5 for="">البحث</h5>
          <input type="text"
            class="form-control form-control-lg" v-model="q" @change="search()" placeholder="ابحث عن حاج...">
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" @click="search()"><i class="fa fa-search"></i> بحث عن الحاج</button>
        </div><br>
        <div class="col-12 table-responsive">
            <table class="table table-sm table-bordered table-hover">
                <thead>
                    <th>
                        الاسم
                    </th>
                    <th>
                        رقم الهوية
                    </th>
                    <th>
                        الجوال
                    </th>
                    <th>
                        رقم الحجز
                    </th>
                    <th>
                        سكن منى
                    </th>
                </thead>
                <tbody>
                    <tr v-for="(u,v) in filtered" :key="v">
                        <td>
                            {{ u.name }}
                        </td>
                        <td>
                            {{ u.number }}
                        </td>
                        <td>
                            {{ u.phone }}
                        </td>
                        <td>
                            {{ u.order_id }}
                        </td>
                        <td>
                            {{ u.camp_obj.title }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            users: [],
            user: JSON.parse(localStorage.getItem('user')),
            q: "",
            filtered: []
        }
    },
    created(){
        var g = this;
        $.post(api + '/admin/users/list', {
            all: true,
            jwt: this.user.jwt,
            q: "",
            hamla: "all",
            page: 0,
            status: "all",
            start_location: "all",
            deleted: false,
            bus_id: "all",
            gender: "all",
            camp_id: "all",
            camp2_id: "all"
        }).then(function(a){
            g.users = a.response;
            g.filtered = a.response;
        })
    },
    methods: {
        search(){
            var g = this;
            var a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
            g.filtered = g.users.filter(function(a){
                if(g.q && g.q != ""){
                    g.q = a2e(g.q)
                    if(!a?.name?.includes(g.q) && !a?.number?.includes(g.q) && !a?.phone?.includes(g.q) && !a?.order_id?.includes(g.q)){
                        return false;
                    }
                }
                return a;
            })
        }
    }
}
</script>

<style>

</style>